export default {
  App: {
    title: '信息互联，从me开启'
  },
  // views/logic/homePage/index.vue
  loigcHomePageIndex: {
    // 申请试用联系我们的两个小模块
    applyForTrial: '申请试用',
    contactUs: '联系我们',
    // 轮播图下方显示的4个小模块
    pictureSuspensionTitle1: '快速自建接口',
    pictureSuspensionData1: '快速自建对外接口，不改变现有系统，实现对外开放联通',
    pictureSuspensionTitle2: '多数据规格集成',
    pictureSuspensionData2: '消除数据平台间规格差异，实现数据规格统一，高效有序',
    pictureSuspensionTitle3: '多平台信息互联',
    pictureSuspensionData3: '通过接口的主动或被动等调用方式，打开平台壁垒，实现信息互联互通',
    pictureSuspensionTitle4: '信息互联，通则不疼',
    pictureSuspensionData4: '提升企业系统间交互效率，让信息高效流动，减少症结，消除疼点',
    // 热门应用
    popularApplicationsTitle: '安全、可信、持续创新的产品与服务',
    popularApplicationsButton: '申请试用',
    //解决方案
    successSwitchTitle: '推荐解决方案',
    successSwitchButtonText: '查看全部方案',
    // 解决方案第一部分
    bankEnterpriseInterconnection: {
      label: '银企互联',
      title1: '安全银企直连解决方案',
      data1: '客户财务专用电脑上安装的客户端，定期轮巡中间件服务，获取业务系统的付款等指令，通过预置密码解密并执行相应的银行操作，达到业务和银行直连效果。 该方案无安全隐患，指令在传输过程中全程加密，客户端安装在内网电脑，无外网暴露风险。指令执行结果定时反馈业务系统，全程记录在案，有据可查。',
      title2: '对应银行',
      buttonText: '申请试用',
    },
    // 解决方案第二部分
    systemInterconnection: {
      label: 'OA系统互联解决方案',
      title1: 'OA系统互联解决方案',
      data1: '通过中间件，打通多家OA系统和业务系统的接口，实现多家OA系统的一套接口的互联。',
      title2: '对应OA系统',
      dingding: '钉钉',
      feishu: '飞书',
      qiyeweixin: '企业微信',
      buttonText: '申请试用'
    },
    // 解决方案第三部分
    controlSystemInterconnection: {
      label: '费控系统互联',
      title1: '费控系统互联解决方案',
      data1: '通过中间件，打通多家费用包管控系统和业务系统的接口，实现多家费用管控系统的一套接口的互联。',
      title2: '对应费控系统',
      buttonText: '申请试用'
    },
    // 成功客户
    focusOnCustomers: {
      title: '关注客户成功',
      buttonText: '查看更多',
    },
    // 最下方备注
    fonterTitle: 'Copyright©2022 云科同创(武汉)信息科技有限公司',
    // JS
    // 热门应用
    popularApplicationsList: {
      data1: {
        title: 'OA系统',
        data1: {
          title: '企业微信直连',
          smallTitle: '企业微信的OA等功能和业务系统的集成应用',
          data: ' 将企业微信里的OA相关的单据和业务系统无缝连接，既利用了手机移动端的便利功能，又能和业务系统打通，实现Anytime, Anywhere, Anydevice信息伴随。 '
        },
        data2: {
            title: '钉钉直连',
            smallTitle: '钉钉的审批功能和业务系统的集成应用',
            data: ' 将钉钉的强大审批功能和业务系统无缝连接。 '
        },
        data3: {
          title: '飞书直连',
          smallTitle: '飞书的OA等功能和业务系统的集成应用',
          data: ' 将飞书里的OA相关的单据和业务系统无缝连接，既利用了手机移动端的便利功能，又能和业务系统打通，实现Anytime, Anywhere, Anydevice信息伴随。 '
        },
        data4: {
          title: 'Lark直连',
          smallTitle: '海外飞书Lark的OA等功能和业务系统的集成应用',
          data: ' 将海外版飞书Lark里的OA相关的单据和业务系统无缝连接，既利用了手机移动端的便利功能，又能和业务系统打通，实现Anytime, Anywhere, Anydevice信息伴随。 '
        }
      },
      data2: {
        title: '费用系统',
        data1: {
          title: '易快报',
          smallTitle: '易快报和业务系统的集成应用',
          data: ' 费用报销系统易快报和业务系统的集成应用。该应用提供了面向业务系统的统一接口，该接口可配置，易维护。'
        },
        data2: {
          title: '汇联易',
          smallTitle: '汇联易和业务系统的集成应用',
          data: ' 费用报销系统易汇联易和业务系统的集成应用。该应用提供了面向业务系统的统一接口，该接口可配置，易维护。 '
        }
      },
      data3: {
        title: 'OMS',
        data1: {
          title: '管易云',
          smallTitle: '将管易云OMS和业务系统直连的应用',
          data: ' 将管易云OMS和业务系统直连的应用。面向业务系统，提供业务单据的统一接口，该接口可配置，易维护。 '
        },
        data2: {
          title: '易仓',
          smallTitle: '将易仓OMS和业务系统直连的应用',
          data: ' 将易仓OMS和业务系统直连的应用。面向业务系统，提供业务单据的统一接口，该接口可配置，易维护。 '
        }
      },
      data4: {
        title: '电商平台'
      }
    },
    // 轮播图上显示的信息
    lunboImage1: {
      topLeftData: '互通互换',
      topRightData: '智慧数据',
      h1Data: '打通企业任督二脉，实现数据快速流通',
      pData: '助力企业快速打通系统间的信息壁垒，实现不同系统间的高速互通与数据互换、稳定高效处理与分析'
    },
    lunboImage2: {
      topLeftData: '规范有序',
      topRightData: '智慧数据',
      h1Data: '统一数据规格，实现数据规范有序',
      pData: '助力企业统一数据接口规范，让数据的来和去，井井有序，让企业运营数据的每一个节点都高效有序、稳定高效处理与分析'
    },
  },
  // views/logic/contanctUs/index.vue 联系我们页面
  loigcContactUsIndex: {
    title: '联系我们',
    showData: '售前团队为您提供售前咨询、产品及解决方案推荐、配置推荐等服务，助您开启互联，信息畅通！',
    formName: '姓名',
    formEmail: 'E-mail',
    formCorporateName: '公司名称',
    formPosition: '职位',
    formPhone: '手机号码',
    formTextArea: '咨询内容',
    buttonSubmit: '提交',
    // 下方备注
    fonterTitle: 'Copyright©2022 云科同创(武汉)信息科技有限公司',
    // JS
    rules: {
      phoneCannotNull: '手机号不能为空',
      inputSuccessPhone: '请输入正确的手机号',
      inputSuccessEmail: '请正确填写邮箱',
      inputEffectiveEmail: '请输入有效的邮箱',
      nameRule: '请输入名称',
      emailRule: '请输入邮箱',
      phoneRule: '请输入手机号'
    },
    subject: '云直连-产品-联系我们-邮件',
    sendSuccessTip: '发送成功',
  },
  // components/topBar/index.vue
  baseSwiperIndex: {
    connectUsTitle: '联系我们',
    register: '注册',
    welcomeWord: '你好',
    // JS
    showCenterDataList1: '应用场景',
    showCenterDataList2: '热门应用',
    showCenterDataList3: '解决方案',
    showCenterDataList4: '成功客户',
    console: '控制台',
    signOut: '退出',
    login: '登录'
  }
}



// WEBPACK FOOTER //
// ./src/lang/zh.js